export default __webpack_public_path__ + "static/media/count1.cbb609bd.svg";